import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EJsonQueryActionTypes {
  Merge = 'JSON_QUERY/MERGE',
  Set = 'JSON_QUERY/SET',
  Extract = 'JSON_QUERY/EXTRACT',
  Clear = 'JSON_QUERY/CLEAR',
}

export type TSetJsonQuery = ITypedReduxAction<EJsonQueryActionTypes.Set, IJsonQuery>;
export type TMergeJsonQuery = ITypedReduxAction<EJsonQueryActionTypes.Merge, IJsonQuery>;
export type TExtractJsonQuery = ITypedReduxAction<EJsonQueryActionTypes.Extract, IJsonQuery>;
export type TClearJsonQuery = ITypedReduxAction<EJsonQueryActionTypes.Clear>;

/**
 * Redux action, который записывает в store параметры поиска
 * @param jsonQuery IJsonQuery
 */
export const setJsonQueryAction: (jsonQuery: IJsonQuery) => TSetJsonQuery = actionGenerator<
  EJsonQueryActionTypes.Set,
  IJsonQuery
>(EJsonQueryActionTypes.Set);
/**
 * Redux action, который складывает переданный параметр поиска с текущим и записывает в store
 * @param jsonQuery IJsonQuery
 */
export const mergeJsonQueryAction: (jsonQuery: IJsonQuery) => TMergeJsonQuery = actionGenerator<
  EJsonQueryActionTypes.Merge,
  IJsonQuery
>(EJsonQueryActionTypes.Merge);
/**
 * Redux action, который вычитает переданный параметр поиска из текущего и записывает в store
 * @param jsonQuery IJsonQuery
 */
export const extractJsonQueryAction: (jsonQuery: IJsonQuery) => TExtractJsonQuery = actionGenerator<
  EJsonQueryActionTypes.Extract,
  IJsonQuery
>(EJsonQueryActionTypes.Extract);

/**
 * Redux action, который скидывает все значения jsonQuery и записывает в store
 * @param jsonQuery IJsonQuery
 */
export const clearJsonQueryAction: () => TClearJsonQuery = actionGenerator<EJsonQueryActionTypes.Clear>(
  EJsonQueryActionTypes.Clear,
);
